var map = {
	"./data.svg": "RUrO",
	"./device.svg": "k6Cd",
	"./enroll.svg": "6ZSS",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./face.svg": "A76F",
	"./form.svg": "sTIr",
	"./goods-order.svg": "XkOO",
	"./goods-refund.svg": "p0pA",
	"./goods.svg": "XNJ4",
	"./home.svg": "U9Ws",
	"./isv.svg": "N0uV",
	"./jfd.svg": "T0Lt",
	"./jfgl.svg": "cmcT",
	"./jfjl.svg": "z0PD",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./meichantaccount.svg": "7Al2",
	"./merchant.svg": "8OX1",
	"./merchant1.svg": "mVBY",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./partner.svg": "EwS/",
	"./password.svg": "QjmH",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./refund.svg": "GeoZ",
	"./report.svg": "2nwU",
	"./report1.svg": "rSqQ",
	"./school.svg": "cVkD",
	"./schoolChild.svg": "AGut",
	"./schoolmanage.svg": "JX5u",
	"./server-config.svg": "ye/w",
	"./server.svg": "2Sb8",
	"./shoolxiaofu.svg": "tNhI",
	"./shop.svg": "hert",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./svg-tkjl.svg": "ZB/l",
	"./svg-tuikuan.svg": "5gbV",
	"./svg-ytk.svg": "R5P4",
	"./system-info.svg": "OhMH",
	"./table.svg": "oSYw",
	"./tags.svg": "vNLF",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./trading.svg": "3S/4",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./uniform_config1.svg": "EfSH",
	"./uniforn_config.svg": "hucP",
	"./user.svg": "VdD3",
	"./verify.svg": "eoik",
	"./vx-jiaofei.svg": "k9mA",
	"./withHold.svg": "IgSI",
	"./xiaofu.svg": "rOtK",
	"./zfb.svg": "T9eF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 60